import { Backdrop } from "@mui/material";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/lottie/Loading.json";
import "./index.scss";

const LoadingSpinner = ({ open }) => {
  return (
    <Backdrop className="global-loading" open={open}>
      <div className="global-loading__card">
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          autoplay={true}
          className="global-loading__spinner"
        />
        <p className="global-loading__text">Loading... Please wait</p>
      </div>
    </Backdrop>
  );
};

export default LoadingSpinner;
